import React from "react";
// import avitar from "../avitar.png"   you can import or use require
import '../certs.css';


export default function Certificates() {
  return (
    <div className="certs">
    <div  id="certificate"> 
      <img id="typescript" src={require('../images/typescrypt cert.jpg')} alt="pic"/>
      <img id="stack" src={require('../images/fullStackBootcamp.jpg')} alt="pic"/>
      <img id="nft" src={require('../images/NFT Market place.jpg')} alt="pic"/> 
      <img id="sol" src={require('../images/advancedSolidityCert.jpg')} alt="pic"/> 
      <img id="blockchain" src={require('../images/blockchain.jpg')} alt="pic"/>  
    </div>
     
      
    </div>
  );
}